// The new, streamlined interface (9 October 2026): the shell.
export default {
  nav: {
    aria: 'Main navigation',
    veille: 'Watch',
    formats: 'Formats',
    reglages: 'Settings',
    replier: 'Collapse navigation',
    deplier: 'Expand navigation',
    ouvrir: 'Open navigation',
    fermer: 'Close navigation',
  },
  theme: {
    sombre: 'Dark',
    clair: 'Light',
  },
  pagination: {
    resume: '{debut} to {fin} of {total}',
    precedente: 'Previous page',
    suivante: 'Next page',
    page: 'Page {n}',
  },
}
